import { councilCustomerApi } from "@/lib/api"
import { useInfiniteQuery } from "@tanstack/react-query"
import {
  type CustomerDTO,
  type ApiResponsePaginatedResponseDTOCustomerDTO,
} from "@/gen/api"

type Customer = CustomerDTO
type CustomerPage = { customers: Customer[]; nextPage: number | null }

const PAGE_SIZE = 10

const fetchCustomerPage = async (
  councilId: string,
  page: number,
  search?: string,
  status?: string,
): Promise<CustomerPage> => {
  const response = await councilCustomerApi.getCouncilCustomers(
    councilId,
    search,
    status,
    page,
    PAGE_SIZE,
  )
  const data = (response.data as ApiResponsePaginatedResponseDTOCustomerDTO).data
  return {
    customers: data?.items ?? [],
    nextPage:
      (data?.currentPage ?? -1) < (data?.totalPages ?? 0) - 1 ? (data?.currentPage ?? 0) + 1 : null,
  }
}

const customerListApi = async (
  councilId: string,
  page: number,
  search?: string,
  status?: string,
): Promise<CustomerPage> => {
  return fetchCustomerPage(councilId, page, search, status)
}

export const useGetCustomerList = (councilId: string, search?: string, status?: string) => {
  return useInfiniteQuery<CustomerPage>({
    queryKey: [useGetCustomerList.QUERY_KEY, councilId, search, status],
    queryFn: ({ pageParam }) => customerListApi(councilId, pageParam as number, search, status),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  })
}

useGetCustomerList.QUERY_KEY = "customers"
